import React, { FC, useCallback, memo, useMemo } from 'react'
import { Button, Table } from '@wmgtech/legato'
import { ColumnsType } from '@wmgtech/legato/build/components/Table/types'
import { useFreezeModal } from 'shared/hooks'

import { ConditionRender } from 'components'
import { ProductMatchModalProps } from './ProductMatchModal.props'

import './ProductMatchModal.scss'

const ProductMatchModal: FC<ProductMatchModalProps> = memo(
  ({ onUpdateDvId, onDeleteHandler, assignedGridList, artistProductsResult }) => {
    useFreezeModal()

    const onHandleClick = useCallback((product) => () => onUpdateDvId(product), [onUpdateDvId])

    const columns = useMemo<ColumnsType<unknown>[]>(
      () => [
        {
          dataIndex: 'artistDisplayTitle',
          key: 'artistDisplayTitle',
          title: 'Artist',
          width: '30%',
          sortable: false
        },
        {
          dataIndex: 'displayTitle',
          key: 'displayTitle',
          title: 'Product',
          width: '45%',
          sortable: false
        },
        {
          dataIndex: 'status',
          key: 'status',
          title: 'Status',
          sortable: false,
          render: (_: any, result: any) => (
            <Button
              onClick={onHandleClick(result)}
              containerStyle={result.gpid_list.toString() === assignedGridList.toString() ? 'solid' : 'outline'}
              colorType="secondary-black"
              label={result.gpid_list.toString() === assignedGridList.toString() ? 'Assigned' : 'Assign'}
            />
          )
        }
      ],
      [assignedGridList, onHandleClick]
    )

    return (
      <div className="product-match-modal__body">
        <p>
          Storybox searches GCDM to find product matches for products created in Storybox. Because many products are
          entered into Storybox before a product is released, we search daily to find a match in GCDM. Once it has been
          added to the database, you'll get a notification for a new potential match. If you see a match, click assign.
          If not, you'll be notified the next time a potential match is found.
        </p>
        <p>
          If a product is out in the charts and a match is still not found, contact{' '}
          <a className="link" href="mailto:maria.dilling@warnermusic.com">
            maria.dilling@warnermusic.com
          </a>
          .
        </p>
        <div className="product-match-modal__action">
          <ConditionRender
            condition={!assignedGridList.length}
            component={<Button onClick={onDeleteHandler} label="Remove all suggestions" colorType="secondary-black" />}
          />
        </div>
        <Table
          className="product-match-modal__table"
          rowKey={(record: any) => record.id}
          columns={columns}
          data={artistProductsResult}
          pagination={false}
          condensed
          sticky
        />
      </div>
    )
  }
)

export default ProductMatchModal
